function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 14 16"
}, props), React.createElement("path", {
  d: "M7 16c.14 0 .35-.05.56-.15 4.87-2.4 6.44-3.6 6.44-6.49V3.29c0-.83-.38-1.1-1.1-1.37-1-.4-4.2-1.49-5.19-1.8a2.38 2.38 0 00-1.41 0c-1 .3-4.2 1.42-5.2 1.8-.71.27-1.1.54-1.1 1.37v6.07c0 2.89 1.65 3.95 6.44 6.49.22.11.42.15.56.15z"
})));